import React, { useState } from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import ContractorFinancialDetailsForm from './ContractorFinancialDetailsForm';
import { useTranslation } from 'react-i18next';
import AlertPopup from '@rd-web-markets/shared/dist/AlertPopup';
import UnsavedChangesPrompt from '@rd-web-markets/shared/dist/components/UnsavedChangesPrompt';
import CountrySelect from './CountrySelect';
import StateSelect from './StateSelect';
import MemberState from './MemberState';
import TaxNumberForm from './TaxNumberForm';
import ContractorInvoiceTotals from './ContractorInvoiceTotals';
import ContractorFurtherDetails from './ContractorFurtherDetails';
const ProjectContractorForm = _ref => {
  var _contractor$research_, _contractor$partners_, _contractor$legal_for, _window$MARKET_CONSTA2, _contractor$street, _contractor$house_num, _contractor$additiona, _contractor$location, _contractor$postcode, _contractor$additiona2, _contractor$rnd_work_, _contractor$rnd_work_2;
  let {
    projectElsterDetailId,
    isVersion8,
    handleDeleteDetail,
    handleCreateDetail,
    addFile,
    handleFinancialDetailChange,
    saveFinancialDetailChange,
    handleChange,
    contractor,
    handleSubmit,
    saveFinancialYearChange,
    closeForm,
    removeAttachment,
    setSelectedContractor,
    loading,
    applicationSubmitted,
    setSelectedYear,
    selectedYear
  } = _ref;
  const {
    t
  } = useTranslation();
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [financialDetailsHasUnsavedChanges, setFinancialDetailsHasUnsavedChanges] = useState(false);
  const wrappedHandleChange = e => {
    setHasUnsavedChanges(true);
    handleChange(e);
  };
  const wrappedHandleSubmit = async () => {
    await handleSubmit();
    setHasUnsavedChanges(false);
  };
  const handleCloseForm = () => {
    if (hasUnsavedChanges || financialDetailsHasUnsavedChanges) {
      var _window$MARKET_CONSTA;
      const message = t((_window$MARKET_CONSTA = window.MARKET_CONSTANTS) === null || _window$MARKET_CONSTA === void 0 ? void 0 : _window$MARKET_CONSTA.UNSAVED_CHANGES_MESSAGE);
      if (window.confirm(message)) {
        setHasUnsavedChanges(false);
        setFinancialDetailsHasUnsavedChanges(false);
        closeForm();
      }
    } else {
      closeForm();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('research_institute_name'), "*"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    value: (_contractor$research_ = contractor.research_institute_name) !== null && _contractor$research_ !== void 0 ? _contractor$research_ : '',
    name: "research_institute_name",
    onChange: wrappedHandleChange,
    size: "md",
    type: "text",
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('contracting_partners_type'), "*"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "partners_type",
    onChange: wrappedHandleChange,
    size: "md",
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz',
    value: (_contractor$partners_ = contractor.partners_type) !== null && _contractor$partners_ !== void 0 ? _contractor$partners_ : ''
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), /*#__PURE__*/React.createElement("option", {
    value: "unaffiliated_company"
  }, t('other_unaffiliated_company')), /*#__PURE__*/React.createElement("option", {
    value: "affiliated_company"
  }, t('affiliated_company')), /*#__PURE__*/React.createElement("option", {
    value: "research_institute"
  }, t('research_institute')), /*#__PURE__*/React.createElement("option", {
    value: "university"
  }, t('university')), /*#__PURE__*/React.createElement("option", {
    value: "unknown"
  }, t('contractor_unknown'))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('legal_form'), "*"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "legal_form",
    onChange: wrappedHandleChange,
    size: "md",
    value: (_contractor$legal_for = contractor.legal_form) !== null && _contractor$legal_for !== void 0 ? _contractor$legal_for : '',
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }, (_window$MARKET_CONSTA2 = window.MARKET_CONSTANTS) === null || _window$MARKET_CONSTA2 === void 0 || (_window$MARKET_CONSTA2 = _window$MARKET_CONSTA2.LEGAL_FORM_OPTIONS) === null || _window$MARKET_CONSTA2 === void 0 ? void 0 : _window$MARKET_CONSTA2.map(option => /*#__PURE__*/React.createElement("option", {
    key: option.value,
    value: option.value
  }, t(option.translationKey)))))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('street'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    onChange: wrappedHandleChange,
    name: "street",
    value: (_contractor$street = contractor.street) !== null && _contractor$street !== void 0 ? _contractor$street : '',
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('house_number'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    onChange: wrappedHandleChange,
    name: "house_number",
    value: (_contractor$house_num = contractor.house_number) !== null && _contractor$house_num !== void 0 ? _contractor$house_num : '',
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('additional_house_number_details')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "additional_house_number_details",
    onChange: wrappedHandleChange,
    value: (_contractor$additiona = contractor.additional_house_number_details) !== null && _contractor$additiona !== void 0 ? _contractor$additiona : '',
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('location'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    onChange: wrappedHandleChange,
    name: "location",
    value: (_contractor$location = contractor.location) !== null && _contractor$location !== void 0 ? _contractor$location : '',
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('post_code'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    onChange: wrappedHandleChange,
    name: "postcode",
    value: (_contractor$postcode = contractor.postcode) !== null && _contractor$postcode !== void 0 ? _contractor$postcode : '',
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('additional_address_details')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "additional_address_details",
    onChange: wrappedHandleChange,
    value: (_contractor$additiona2 = contractor.additional_address_details) !== null && _contractor$additiona2 !== void 0 ? _contractor$additiona2 : '',
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(CountrySelect, {
    value: contractor.country,
    onChange: wrappedHandleChange,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }), contractor.country === 'Germany' && /*#__PURE__*/React.createElement(StateSelect, {
    value: contractor.state_of_tax_office,
    onChange: wrappedHandleChange,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(MemberState, {
    country: contractor.country
  }), /*#__PURE__*/React.createElement(TaxNumberForm, {
    value: contractor.has_tax_number,
    onChange: wrappedHandleChange,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('description_on_the_commissioned_rd_work_and_associated_objectives'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "rnd_work_objectives",
    onChange: wrappedHandleChange,
    value: (_contractor$rnd_work_ = contractor.rnd_work_objectives) !== null && _contractor$rnd_work_ !== void 0 ? _contractor$rnd_work_ : '',
    as: "textarea",
    rows: 16,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Col, {
    md: {
      offset: 11,
      span: 1
    }
  }, ((_contractor$rnd_work_2 = contractor.rnd_work_objectives) === null || _contractor$rnd_work_2 === void 0 ? void 0 : _contractor$rnd_work_2.length) || 0, " / 500"))), projectElsterDetailId && contractor.id && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(ContractorFurtherDetails, {
    contractor: contractor,
    onChange: wrappedHandleChange,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Row, {
    style: {
      marginBottom: '50px'
    }
  }, /*#__PURE__*/React.createElement(ContractorInvoiceTotals, {
    contractor: contractor,
    isVersion8: isVersion8
  }))), contractor.id && /*#__PURE__*/React.createElement(ContractorFinancialDetailsForm, {
    setSelectedYear: setSelectedYear,
    selectedYear: selectedYear,
    loading: loading,
    applicationSubmitted: applicationSubmitted && contractor.contractor_type === 'bfsz',
    addFile: addFile,
    contractor: contractor,
    saveFinancialYearChange: saveFinancialYearChange,
    handleFinancialDetailChange: handleFinancialDetailChange,
    saveFinancialDetailChange: saveFinancialDetailChange,
    handleCreateDetail: handleCreateDetail,
    handleDeleteDetail: handleDeleteDetail,
    removeAttachment: removeAttachment,
    setSelectedContractor: setSelectedContractor,
    handleChange: wrappedHandleChange,
    handleSubmit: wrappedHandleSubmit,
    closeForm: handleCloseForm,
    setHasUnsavedChanges: setFinancialDetailsHasUnsavedChanges
  })), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: wrappedHandleSubmit,
    icon: "save",
    iconPosition: 'left',
    loading: loading,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz',
    variant: "primary"
  }, t('save')), /*#__PURE__*/React.createElement(Button, {
    className: "ms-2",
    onClick: handleCloseForm,
    loading: loading,
    variant: "light"
  }, t('close_form'))))));
};
export default ProjectContractorForm;